<template>
  <div>
    <el-drawer
    :visible.sync="visible"
    :direction="direction"
    :before-close="handleClose">
    <span slot="title" class="title">{{$t('complaintList.highSearch')}}</span>
    <div class="filter-box">
    <!-- -->

    <div class="row"  v-if="['generalOrder','applyDevice','generalSaleMachinehour','generalSaleMachinehourMoney'].includes(defaultInfo.formType)" >
            <span class="label">{{$t('checkChild.totalCode')}}：</span>
            <div class="col">
            <el-select clearable filterable v-model="form.generalCode" :placeholder="$t('loginUserlogin.pleChoice')">
                <el-option
                v-for="(item,index) in genCodeOptions"
                :key="index+'n'"
                :label="item.code"
                :value="item.code">
                </el-option>
            </el-select>
            </div>
        </div>

       <div class="row" v-if="['generalOrder','applyDevice','generalSaleMachinehour','generalSaleMachinehourMoney'].includes(defaultInfo.formType)" >
            <span class="label">{{$t('checkChild.totalName')}}：</span>
            <div class="col">
            <el-select clearable filterable v-model="form.generalName" :placeholder="$t('loginUserlogin.pleChoice')">
                <el-option
                v-for="(item,index) in genNameOptions"
                :key="index+'t'"
                :label="item.name"
                :value="item.name">
                </el-option>
            </el-select>
            </div>
        </div>

    <div class="row"  v-if="['generalSaleMachinehourMoney','applyDevice','generalSaleMachinehour'].includes(defaultInfo.formType)" >
            <span class="label">{{$t('archiveManagerleaseDetail.areaCode')}}：</span>
            <div class="col">
            <el-select clearable filterable v-model="form.areaCode" :placeholder="$t('loginUserlogin.pleChoice')">
                <el-option
                v-for="(item,index) in areaCodeOptions"
                :key="index+'n'"
                :label="item.code"
                :value="item.code">
                </el-option>
            </el-select>
            </div>
        </div>

       <div class="row" v-if="['generalSaleMachinehourMoney','applyDevice','generalSaleMachinehour'].includes(defaultInfo.formType)" >
            <span class="label">{{$t('archiveManagerleaseDetail.areaName')}}：</span>
            <div class="col">
            <el-select clearable filterable v-model="form.areaName" :placeholder="$t('loginUserlogin.pleChoice')">
                <el-option
                v-for="(item,index) in areaNameOptions"
                :key="index+'t'"
                :label="item.name"
                :value="item.name">
                </el-option>
            </el-select>
            </div>
        </div>
         <!-- v-if="!['generalSaleMachinehourMoney'].includes(defaultInfo.formType)"  -->
        <div class="row" >
            <span class="label">{{$t('applyChildDetail.storeCode')}}：</span>
            <div class="col">
            <el-select clearable filterable v-model="form.shopCode" :placeholder="$t('loginUserlogin.pleChoice')">
                <el-option
                v-for="(item,index) in shopCodeOptions"
                :key="index+'b'"
                :label="item.code"
                :value="item.code">
                </el-option>
            </el-select>
            </div>
        </div>

<!---->
        <div class="row" >
            <span class="label">{{$t('applyChildDetail.storeName')}}：</span>
            <div class="col">
            <el-select clearable filterable v-model="form.shopName" :placeholder="$t('loginUserlogin.pleChoice')">
                <el-option
                v-for="(item,index)  in shopNameOptions"
                :key="index+'a'"
                :label="item.name"
                :value="item.name">
                </el-option>
            </el-select>
            </div>
        </div>
     <!-- v-if="!['generalSaleMachinehourMoney'].includes(defaultInfo.formType)" -->
        <div class="row">
            <span class="label">{{$t('reportfilter.productType')}}：</span>
            <div class="col">
            <el-select clearable filterable v-model="form.type" :placeholder="$t('loginUserlogin.pleChoice')">
                <el-option
                v-for="item in goodsOptions"
                :key="item.value+'s'"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
            </div>
        </div>
        <div class="row" v-if="['generalSaleMachinehourMoney'].includes(defaultInfo.formType)">
            <span class="label">{{$t('reportfilter.preType')}}：</span>
            <div class="col">
            <el-select clearable filterable v-model="form.buyType" :placeholder="$t('loginUserlogin.pleChoice')">
                <el-option
                v-for="item in buyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
            </div>
        </div>
        <div class="row">
            <span class="label">{{$t('reportfilter.startEndDate')}}：</span>
            <div class="col">
                <el-date-picker
                v-model="form.startTime"
                 value-format="yyyy-MM-dd"
                type="date"
                :placeholder="$t('reportfilter.choStartEndDate')">
                </el-date-picker>
            </div>
        </div>
        <div class="row">
            <span class="label">{{$t('complaintList.endTime')}}：</span>
            <div class="col">
                <el-date-picker
                v-model="form.endTime"
                 value-format="yyyy-MM-dd"
                type="date"
                :placeholder="$t('reportfilter.choEndDate')">
                </el-date-picker>
            </div>
        </div>
    </div>
    <div class="btns">
        <el-button class="cancel-btn" @click="handleClose">{{$t('reportfilter.reset')}}</el-button>
        <el-button class="confirm-btn" @click="submit">{{$t('indexTags.sure')}}</el-button>
    </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  shopApplyDevicelist,
  areaArchivelist
} from "@/api/archive"
import { searchurl} from "@/api/search"
  export default {
    props: {
      visible: { default: false },
      defaultInfo: {
        default: () => {
            return {};
        }
      },
    },
    data() {
      return {
        direction: 'rtl',
        form: {
          type: '',
          generalCode: '',
          generalName: '',
          areaCode: "",
          areaName: "",
          shopcode: "",
         shopName:'',
          buyType: '',
          startTime: '',
          endTime: ''
        },
        genCodeOptions:[
            {
                value: '0',
                label: this.$t('applyChild.all')
            } ],
        genNameOptions:[
            {
                value: '0',
                label: this.$t('applyChild.all')
            }],
        areaCodeOptions:[
            {
                value: '0',
                label: this.$t('applyChild.all')
            } ],
        areaNameOptions:[
            {
                value: '0',
                label: this.$t('applyChild.all')
            }],
        shopCodeOptions:[
            {
                value: '0',
                label: this.$t('applyChild.all')
            }],
        shopNameOptions:[
            {
                value: '0',
                label: this.$t('applyChild.all')
            } ],

        goodsOptions: [
            {
                value: '0',
                label: this.$t('applyChild.all')
            },
            {
                value: '1',
                label: this.$t('goodsDetail.product')
            },
            {
                value: '2',
                label: this.$t('goodsDetail.part')
            },
            {
                value: '3',
                label: this.$t('reportfilter.accessories')
            },
        ],
        buyOptions: [
            {
                value: '0',
                label: this.$t('applyChild.all')
            },
            {
                value: '1',
                label: this.$t('reportfilter.purchase')
            },
            {
                value: '2',
                label: this.$t('reportfilter.give')
            },
        ]
      }
    },
    created() {
     console.log(this.defaultInfo,'create--');
     if(this.defaultInfo) {
        this.form.type = this.defaultInfo.filterObj.type;
        this.form.startTime = this.defaultInfo.filterObj.startTime;
        this.form.endTime = this.defaultInfo.filterObj.endTime;
        this.form.buyType = this.defaultInfo.filterObj.buyType;
     }
    },
    mounted () {

        this.getAreaOption()
        this.getShopOption()
        this.getGenOption()
    },
    methods: {
      handleClose() {
        this.$emit("update:visible", false);
      },
      submit() {
        console.log(this.form);
        this.$emit('faction', this.form);
        this.handleClose();
      },
      async getAreaOption () {
        let data =  await areaArchivelist()
        console.log(data.data.data,'---getAreaOption')
        this.areaCodeOptions =data.data.data
        this.areaNameOptions =data.data.data
      },

       async getGenOption () {
        let data =  await searchurl.genArchivelist()
        console.log(data.data.data,'---getAreaOption')
        this.genCodeOptions =data.data.data
        this.genNameOptions =data.data.data
      },


      async getShopOption () {
        let data =  await shopApplyDevicelist()
         console.log(data.data.data,'---getShopOption')
        this.shopCodeOptions =data.data.data
        this.shopNameOptions =data.data.data
        // console.log(data.data.data,'---getAreaOption')
      },
    }
  };
</script>

<style lang="scss" scoped>
/deep/ #el-drawer__title .title {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #333333;
}

.filter-box {
    position: relative;
    padding: 0 51px;
}

.row {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.label {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    min-width: 15%;
}

.col {
    flex: 1;
}

.btns {
    position: absolute;
    left: 50%;
    bottom: 93px;
    transform: translate(-50%, 0);
    .cancel-btn {
        color: #50C4CB;
        border-color: #50C4CB;
    }
    .confirm-btn {
        background-color: #50C4CB;
        color: #fff;
    }
}
</style>
